// ----------------------
// <auto-generated>
// Generated by PermissionsGenerator.
// </auto-generated>
// ----------------------

export class AdministrationPermissions {
    static _ = 'Administration';

    static User = class {
        static _ = 'Administration.User';

        static viewAll = 'Administration.User.ViewAll';
        static viewOwn = 'Administration.User.ViewOwn';
        static edit = 'Administration.User.Edit';
        static create = 'Administration.User.Create';
        static export = 'Administration.User.Export';
    };

    static Role = class {
        static _ = 'Administration.Role';

        static viewAll = 'Administration.Role.ViewAll';
        static viewOwn = 'Administration.Role.ViewOwn';
        static edit = 'Administration.Role.Edit';
        static create = 'Administration.Role.Create';
    };

    static Organization = class {
        static _ = 'Administration.Organization';

        static viewAll = 'Administration.Organization.ViewAll';
        static viewOwn = 'Administration.Organization.ViewOwn';
        static edit = 'Administration.Organization.Edit';
        static create = 'Administration.Organization.Create';
        static export = 'Administration.Organization.Export';
    };

    static Settings = class {
        static _ = 'Administration.Settings';

        static view = 'Administration.Settings.View';
        static edit = 'Administration.Settings.Edit';
    };

}

export class CodeListPermissions {
    static _ = 'CodeList';

    static Country = class {
        static _ = 'CodeList.Country';

        static view = 'CodeList.Country.View';
        static edit = 'CodeList.Country.Edit';
        static create = 'CodeList.Country.Create';
    };

    static Location = class {
        static _ = 'CodeList.Location';

        static view = 'CodeList.Location.View';
        static edit = 'CodeList.Location.Edit';
        static create = 'CodeList.Location.Create';
    };

    static TerminalOperator = class {
        static _ = 'CodeList.TerminalOperator';

        static view = 'CodeList.TerminalOperator.View';
        static edit = 'CodeList.TerminalOperator.Edit';
        static create = 'CodeList.TerminalOperator.Create';
    };

    static Berth = class {
        static _ = 'CodeList.Berth';

        static view = 'CodeList.Berth.View';
        static edit = 'CodeList.Berth.Edit';
        static create = 'CodeList.Berth.Create';
    };

    static BerthRestriction = class {
        static _ = 'CodeList.BerthRestriction';

        static view = 'CodeList.BerthRestriction.View';
        static edit = 'CodeList.BerthRestriction.Edit';
        static create = 'CodeList.BerthRestriction.Create';
    };

    static TowageNote = class {
        static _ = 'CodeList.TowageNote';

        static view = 'CodeList.TowageNote.View';
        static edit = 'CodeList.TowageNote.Edit';
        static create = 'CodeList.TowageNote.Create';
    };

    static ServiceBoat = class {
        static _ = 'CodeList.ServiceBoat';

        static view = 'CodeList.ServiceBoat.View';
        static edit = 'CodeList.ServiceBoat.Edit';
        static create = 'CodeList.ServiceBoat.Create';
    };

    static LaunchOperator = class {
        static _ = 'CodeList.LaunchOperator';

        static view = 'CodeList.LaunchOperator.View';
        static edit = 'CodeList.LaunchOperator.Edit';
        static create = 'CodeList.LaunchOperator.Create';
    };

    static VesselSource = class {
        static _ = 'CodeList.VesselSource';

        static view = 'CodeList.VesselSource.View';
        static edit = 'CodeList.VesselSource.Edit';
        static create = 'CodeList.VesselSource.Create';
    };

    static VesselType = class {
        static _ = 'CodeList.VesselType';

        static view = 'CodeList.VesselType.View';
        static edit = 'CodeList.VesselType.Edit';
        static create = 'CodeList.VesselType.Create';
    };

    static VesselContactMedium = class {
        static _ = 'CodeList.VesselContactMedium';

        static view = 'CodeList.VesselContactMedium.View';
        static edit = 'CodeList.VesselContactMedium.Edit';
        static create = 'CodeList.VesselContactMedium.Create';
    };

    static CertificateType = class {
        static _ = 'CodeList.CertificateType';

        static view = 'CodeList.CertificateType.View';
        static edit = 'CodeList.CertificateType.Edit';
        static create = 'CodeList.CertificateType.Create';
    };

    static VesselPermitType = class {
        static _ = 'CodeList.VesselPermitType';

        static view = 'CodeList.VesselPermitType.View';
        static edit = 'CodeList.VesselPermitType.Edit';
        static create = 'CodeList.VesselPermitType.Create';
    };

    static ManifestCargoType = class {
        static _ = 'CodeList.ManifestCargoType';

        static view = 'CodeList.ManifestCargoType.View';
        static edit = 'CodeList.ManifestCargoType.Edit';
        static create = 'CodeList.ManifestCargoType.Create';
    };

    static Commodity = class {
        static _ = 'CodeList.Commodity';

        static view = 'CodeList.Commodity.View';
        static edit = 'CodeList.Commodity.Edit';
        static create = 'CodeList.Commodity.Create';
    };

    static MCA = class {
        static _ = 'CodeList.MCA';

        static view = 'CodeList.MCA.View';
        static edit = 'CodeList.MCA.Edit';
        static create = 'CodeList.MCA.Create';
    };

    static VesselActionEntity = class {
        static _ = 'CodeList.VesselActionEntity';

        static view = 'CodeList.VesselActionEntity.View';
        static edit = 'CodeList.VesselActionEntity.Edit';
        static create = 'CodeList.VesselActionEntity.Create';
    };

    static LocationMapping = class {
        static _ = 'CodeList.LocationMapping';

        static view = 'CodeList.LocationMapping.View';
        static edit = 'CodeList.LocationMapping.Edit';
        static create = 'CodeList.LocationMapping.Create';
        static delete = 'CodeList.LocationMapping.Delete';
    };

}

export class ConveyancePermissions {
    static _ = 'Conveyance';

    static View = class {
        static _ = 'Conveyance.View';

        static all = 'Conveyance.View.All';
        static own = 'Conveyance.View.Own';
    };

    static Action = class {
        static _ = 'Conveyance.Action';

        static edit = 'Conveyance.Action.Edit';
        static create = 'Conveyance.Action.Create';
        static send = 'Conveyance.Action.Send';
        static discard = 'Conveyance.Action.Discard';
        static approve = 'Conveyance.Action.Approve';
        static reject = 'Conveyance.Action.Reject';
        static print = 'Conveyance.Action.Print';
        static clone = 'Conveyance.Action.Clone';
        static export = 'Conveyance.Action.Export';
        static cancel = 'Conveyance.Action.Cancel';
        static archive = 'Conveyance.Action.Archive';
        static unconfirm = 'Conveyance.Action.Unconfirm';
    };

}

export class DocumentPermissions {
    static _ = 'Document';

    static View = class {
        static _ = 'Document.View';

        static all = 'Document.View.All';
        static own = 'Document.View.Own';
    };

    static Action = class {
        static _ = 'Document.Action';

        static create = 'Document.Action.Create';
        static edit = 'Document.Action.Edit';
        static delete = 'Document.Action.Delete';
        static archive = 'Document.Action.Archive';
    };

}

export class EmsaPermissions {
    static _ = 'Emsa';

    static View = class {
        static _ = 'Emsa.View';

        static list = 'Emsa.View.List';
    };

    static Action = class {
        static _ = 'Emsa.Action';

        static export = 'Emsa.Action.Export';
        static process = 'Emsa.Action.Process';
        static send = 'Emsa.Action.Send';
    };

}

export class EurostatReportsPermissions {
    static _ = 'EurostatReports';

    static View = class {
        static _ = 'EurostatReports.View';

        static all = 'EurostatReports.View.All';
    };

    static Action = class {
        static _ = 'EurostatReports.Action';

        static export = 'EurostatReports.Action.Export';
    };

}

export class FaqPermissions {
    static _ = 'Faq';

    static View = class {
        static _ = 'Faq.View';

        static all = 'Faq.View.All';
        static own = 'Faq.View.Own';
    };

    static Action = class {
        static _ = 'Faq.Action';

        static create = 'Faq.Action.Create';
        static edit = 'Faq.Action.Edit';
        static delete = 'Faq.Action.Delete';
        static archive = 'Faq.Action.Archive';
    };

}

export class MessagePermissions {
    static _ = 'Message';

    static View = class {
        static _ = 'Message.View';

        static scada = 'Message.View.Scada';
        static edifact = 'Message.View.Edifact';
        static elman = 'Message.View.Elman';
    };

    static Edifact = class {
        static _ = 'Message.Edifact';

        static linkAgent = 'Message.Edifact.LinkAgent';
        static linkAdmin = 'Message.Edifact.LinkAdmin';
    };

    static Elman = class {
        static _ = 'Message.Elman';

        static acknowledge = 'Message.Elman.Acknowledge';
        static link = 'Message.Elman.Link';
        static resend = 'Message.Elman.Resend';
    };

}

export class NoticeBoardPermissions {
    static _ = 'NoticeBoard';

    static View = class {
        static _ = 'NoticeBoard.View';

        static list = 'NoticeBoard.View.List';
        static deactivated = 'NoticeBoard.View.Deactivated';
    };

    static Action = class {
        static _ = 'NoticeBoard.Action';

        static create = 'NoticeBoard.Action.Create';
        static edit = 'NoticeBoard.Action.Edit';
    };

}

export class ParisMOUPermissions {
    static _ = 'ParisMOU';

    static View = class {
        static _ = 'ParisMOU.View';

        static list = 'ParisMOU.View.List';
    };

    static Action = class {
        static _ = 'ParisMOU.Action';

        static create = 'ParisMOU.Action.Create';
        static edit = 'ParisMOU.Action.Edit';
    };

}

export class ShippingManifestPermissions {
    static _ = 'ShippingManifest';

    static View = class {
        static _ = 'ShippingManifest.View';

        static all = 'ShippingManifest.View.All';
        static own = 'ShippingManifest.View.Own';
    };

    static Action = class {
        static _ = 'ShippingManifest.Action';

        static edit = 'ShippingManifest.Action.Edit';
        static upload = 'ShippingManifest.Action.Upload';
        static confirm = 'ShippingManifest.Action.Confirm';
        static unconfirm = 'ShippingManifest.Action.Unconfirm';
        static noCargo = 'ShippingManifest.Action.NoCargo';
        static hasCargo = 'ShippingManifest.Action.HasCargo';
    };

}

export class TowageExemptedVesselPermissions {
    static _ = 'TowageExemptedVessel';

    static View = class {
        static _ = 'TowageExemptedVessel.View';

        static all = 'TowageExemptedVessel.View.All';
    };

    static Action = class {
        static _ = 'TowageExemptedVessel.Action';

        static create = 'TowageExemptedVessel.Action.Create';
        static export = 'TowageExemptedVessel.Action.Export';
        static remove = 'TowageExemptedVessel.Action.Remove';
    };

}

export class TowageRequirementPermissions {
    static _ = 'TowageRequirement';

    static View = class {
        static _ = 'TowageRequirement.View';

        static all = 'TowageRequirement.View.All';
    };

    static Action = class {
        static _ = 'TowageRequirement.Action';

        static create = 'TowageRequirement.Action.Create';
        static edit = 'TowageRequirement.Action.Edit';
        static export = 'TowageRequirement.Action.Export';
        static delete = 'TowageRequirement.Action.Delete';
    };

}

export class VesselNotificationPermissions {
    static _ = 'VesselNotification';

    static View = class {
        static _ = 'VesselNotification.View';

        static all = 'VesselNotification.View.All';
        static own = 'VesselNotification.View.Own';
        static dangerousGoods = 'VesselNotification.View.DangerousGoods';
        static bunkers = 'VesselNotification.View.Bunkers';
        static cargo = 'VesselNotification.View.Cargo';
        static storeProducts = 'VesselNotification.View.StoreProducts';
        static workers = 'VesselNotification.View.Workers';
        static passengers = 'VesselNotification.View.Passengers';
        static security = 'VesselNotification.View.Security';
        static wastes = 'VesselNotification.View.Wastes';
        static mdh = 'VesselNotification.View.Mdh';
        static cruiseItineraries = 'VesselNotification.View.CruiseItineraries';
        static logs = 'VesselNotification.View.Logs';
        static attachments = 'VesselNotification.View.Attachments';
        static accompanied = 'VesselNotification.View.Accompanied';
        static manifests = 'VesselNotification.View.Manifests';
        static permissions = 'VesselNotification.View.Permissions';
        static remarks = 'VesselNotification.View.Remarks';
        static cargoData = 'VesselNotification.View.CargoData';
    };

    static Edit = class {
        static _ = 'VesselNotification.Edit';

        static dangerousGoods = 'VesselNotification.Edit.DangerousGoods';
        static bunkers = 'VesselNotification.Edit.Bunkers';
        static cargo = 'VesselNotification.Edit.Cargo';
        static storeProducts = 'VesselNotification.Edit.StoreProducts';
        static workers = 'VesselNotification.Edit.Workers';
        static passengers = 'VesselNotification.Edit.Passengers';
        static security = 'VesselNotification.Edit.Security';
        static wastes = 'VesselNotification.Edit.Wastes';
        static mdh = 'VesselNotification.Edit.Mdh';
        static cruiseItineraries = 'VesselNotification.Edit.CruiseItineraries';
        static logs = 'VesselNotification.Edit.Logs';
        static attachments = 'VesselNotification.Edit.Attachments';
        static accompanied = 'VesselNotification.Edit.Accompanied';
        static permissions = 'VesselNotification.Edit.Permissions';
        static manifests = 'VesselNotification.Edit.Manifests';
        static remarks = 'VesselNotification.Edit.Remarks';
        static certificates = 'VesselNotification.Edit.Certificates';
        static cargoData = 'VesselNotification.Edit.CargoData';
    };

    static Action = class {
        static _ = 'VesselNotification.Action';

        static edit = 'VesselNotification.Action.Edit';
        static editAllStatus = 'VesselNotification.Action.EditAllStatus';
        static create = 'VesselNotification.Action.Create';
        static upload = 'VesselNotification.Action.Upload';
        static excelUpdate = 'VesselNotification.Action.ExcelUpdate';
        static cancel = 'VesselNotification.Action.Cancel';
        static send = 'VesselNotification.Action.Send';
        static reject = 'VesselNotification.Action.Reject';
        static rejectAll = 'VesselNotification.Action.RejectAll';
        static approve = 'VesselNotification.Action.Approve';
        static approveAll = 'VesselNotification.Action.ApproveAll';
        static clone = 'VesselNotification.Action.Clone';
        static createDeparture = 'VesselNotification.Action.CreateDeparture';
        static print = 'VesselNotification.Action.Print';
        static export = 'VesselNotification.Action.Export';
        static removeAgent = 'VesselNotification.Action.RemoveAgent';
        static unconfirm = 'VesselNotification.Action.Unconfirm';
        static discard = 'VesselNotification.Action.Discard';
        static arrive = 'VesselNotification.Action.Arrive';
        static depart = 'VesselNotification.Action.Depart';
        static createVesselPermit = 'VesselNotification.Action.CreateVesselPermit';
        static portCreatePermit = 'VesselNotification.Action.PortCreatePermit';
        static createConveyance = 'VesselNotification.Action.CreateConveyance';
        static createVesselShift = 'VesselNotification.Action.CreateVesselShift';
        static exportPaxList = 'VesselNotification.Action.ExportPaxList';
        static exportCrewList = 'VesselNotification.Action.ExportCrewList';
        static overhang = 'VesselNotification.Action.Overhang';
        static layUp = 'VesselNotification.Action.LayUp';
        static wasteToBeAdded = 'VesselNotification.Action.WasteToBeAdded';
    };

}

export class VesselPermitPermissions {
    static _ = 'VesselPermit';

    static View = class {
        static _ = 'VesselPermit.View';

        static all = 'VesselPermit.View.All';
        static own = 'VesselPermit.View.Own';
    };

    static Edit = class {
        static _ = 'VesselPermit.Edit';

        static descriptions = 'VesselPermit.Edit.Descriptions';
    };

    static Action = class {
        static _ = 'VesselPermit.Action';

        static edit = 'VesselPermit.Action.Edit';
        static create = 'VesselPermit.Action.Create';
        static send = 'VesselPermit.Action.Send';
        static reject = 'VesselPermit.Action.Reject';
        static approve = 'VesselPermit.Action.Approve';
        static annul = 'VesselPermit.Action.Annul';
        static discard = 'VesselPermit.Action.Discard';
        static extend = 'VesselPermit.Action.Extend';
        static expire = 'VesselPermit.Action.Expire';
        static cancel = 'VesselPermit.Action.Cancel';
        static print = 'VesselPermit.Action.Print';
        static clone = 'VesselPermit.Action.Clone';
        static export = 'VesselPermit.Action.Export';
        static revoke = 'VesselPermit.Action.Revoke';
        static amend = 'VesselPermit.Action.Amend';
        static archive = 'VesselPermit.Action.Archive';
    };

}

export class VesselPermissions {
    static _ = 'Vessel';

    static Action = class {
        static _ = 'Vessel.Action';

        static search = 'Vessel.Action.Search';
        static edit = 'Vessel.Action.Edit';
        static create = 'Vessel.Action.Create';
        static ihsImport = 'Vessel.Action.IhsImport';
        static ihsImportAgent = 'Vessel.Action.IhsImportAgent';
        static emsaImport = 'Vessel.Action.EmsaImport';
        static emsaImportAgent = 'Vessel.Action.EmsaImportAgent';
        static detainVessel = 'Vessel.Action.DetainVessel';
        static releaseVessel = 'Vessel.Action.ReleaseVessel';
        static banVessel = 'Vessel.Action.BanVessel';
        static breakUpVessel = 'Vessel.Action.BreakUpVessel';
    };

    static View = class {
        static _ = 'Vessel.View';

        static all = 'Vessel.View.All';
        static detainedVesselList = 'Vessel.View.DetainedVesselList';
    };

    static Filter = class {
        static _ = 'Vessel.Filter';

        static vesselCountry = 'Vessel.Filter.VesselCountry';
        static vesselName = 'Vessel.Filter.VesselName';
    };

}

export class VesselSchedulePermissions {
    static _ = 'VesselSchedule';

    static View = class {
        static _ = 'VesselSchedule.View';

        static arrivalsAndDepartures = 'VesselSchedule.View.ArrivalsAndDepartures';
    };

}

export class VesselShiftPermissions {
    static _ = 'VesselShift';

    static View = class {
        static _ = 'VesselShift.View';

        static all = 'VesselShift.View.All';
        static own = 'VesselShift.View.Own';
    };

    static Action = class {
        static _ = 'VesselShift.Action';

        static edit = 'VesselShift.Action.Edit';
        static create = 'VesselShift.Action.Create';
        static send = 'VesselShift.Action.Send';
        static reject = 'VesselShift.Action.Reject';
        static approve = 'VesselShift.Action.Approve';
        static cancel = 'VesselShift.Action.Cancel';
        static discard = 'VesselShift.Action.Discard';
        static clone = 'VesselShift.Action.Clone';
        static shift = 'VesselShift.Action.Shift';
        static unconfirm = 'VesselShift.Action.Unconfirm';
    };

}

export class VesselShortNotificationPermissions {
    static _ = 'VesselShortNotification';

    static View = class {
        static _ = 'VesselShortNotification.View';

        static all = 'VesselShortNotification.View.All';
        static own = 'VesselShortNotification.View.Own';
    };

    static Action = class {
        static _ = 'VesselShortNotification.Action';

        static create = 'VesselShortNotification.Action.Create';
    };

}

export class VesselVisitPermissions {
    static _ = 'VesselVisit';

    static View = class {
        static _ = 'VesselVisit.View';

        static all = 'VesselVisit.View.All';
        static own = 'VesselVisit.View.Own';
    };

    static Action = class {
        static _ = 'VesselVisit.Action';

        static export = 'VesselVisit.Action.Export';
    };

}

export class VTSPermissions {
    static _ = 'VTS';

    static View = class {
        static _ = 'VTS.View';

        static all = 'VTS.View.All';
    };

    static User = class {
        static _ = 'VTS.User';

        static officer = 'VTS.User.Officer';
        static supervisor = 'VTS.User.Supervisor';
    };

    static Pilot = class {
        static _ = 'VTS.Pilot';

        static view = 'VTS.Pilot.View';
        static edit = 'VTS.Pilot.Edit';
        static create = 'VTS.Pilot.Create';
    };

    static VtsEvent = class {
        static _ = 'VTS.VtsEvent';

        static edit = 'VTS.VtsEvent.Edit';
        static discard = 'VTS.VtsEvent.Discard';
    };

    static IncidentReport = class {
        static _ = 'VTS.IncidentReport';

        static print = 'VTS.IncidentReport.Print';
        static edit = 'VTS.IncidentReport.Edit';
        static create = 'VTS.IncidentReport.Create';
    };

}


